import axios from "axios";
import { useCallback, useContext, useState } from "react";
import { GlobalStates } from "../GlobalStates";

export const useEmail = () => {
    const { token, path, pathImg } = useContext(GlobalStates);

    const sendEmail = useCallback(async (email) => {
        var data = {
            data: {
                from: '',
                to: '',
                ...email,
            }
        }
        axios
            .post(path + 'mail-to', {

                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            })
            .then((response) => {
                {
                    console.log(response)
                    return response.data.data
                }
            })
            .catch((error) => {
                console.log('An error occurred:', error);
            });
    }, [token, path])

    const emailcheck = useCallback(async (email) => {
        axios
            .post(path + 'check-mail', {
                email: email, // user's email
            })
            .then(response => {
                console.log('email response', response.data);
                if (response.data)
                    return true
                else
                    return false
            })
            .catch(error => {
                console.log('An error occurred:', error.response);
                return false
            });
    }, [])

    const forgotPassword = useCallback(async (email = '') => {
        return axios
            .post(path + 'auth/forgot-password', {
                email: email, // user's email
            })
            .then(response => {
                console.log('Your user received an email');
                return true
            })
            .catch(error => {
                console.log('An error occurred:', error.response);
                return false
            });

    }, [])
    const newPassword = useCallback(async (code = '', password = '', password2 = '') => {
        var data = {
            data: {
                code: code[0], // code contained in the reset link of step 3.
                password: password,
                passwordConfirmation: password2,
            }
        }
        var info = {
            headers: {
                mode: 'cors',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }
        var x = false;
        return axios
            .post(path + 'auth/reset-password', {
                code: code[0], // code contained in the reset link of step 3.
                password: password, // password,
                passwordConfirmation: password2,
            }).then(response => {
                console.log("Your user's password has been reset.");
                return true
            })
            .catch(error => {
                console.log('An error occurred:', error.response);
                return false
            });
    }, [])

    // Request API.

    return {
        sendEmail, forgotPassword, newPassword, emailcheck,
    }
}
